<template>
  <div v-if="size(interviewers)">
    <p class="font-weight-bold mb-1 mt-1">Interviewers</p>
    <v-chip
      class="selected-worker-chip mr-2"
      :key="interviewer"
      v-for="interviewer in interviewers"
    >
      <v-icon>mdi-account</v-icon> {{ interviewer }}
    </v-chip>
    <slot name="details" />
    <div v-if="size(Object.keys(unfilledSlots))">
      <p class="font-weight-bold mt-3 mb-2">Slots</p>
      <GroupedSlotList :slots="unfilledSlots" />
    </div>
  </div>
</template>

<script>
import { size, filter } from "lodash";
import { getInterviewsParticipantsNames } from "@/views/bookings/BookingInterviews/modules/utils";
import GroupedSlotList from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/SelfScheduleInvite/steps/SelfScheduleSlots/components/GroupedSlotList";

export default {
  props: {
    interviewFormat: {
      type: Object,
      required: true
    }
  },
  components: {
    GroupedSlotList
  },
  computed: {
    unfilledSlots() {
      return filter(
        this.interviewFormat.interviewSlots,
        ({ filled }) => !filled
      );
    },
    interviewers() {
      return getInterviewsParticipantsNames(this.unfilledSlots, "interviewer");
    }
  },
  methods: {
    size
  }
};
</script>

<style lang="scss"></style>
